// extracted by mini-css-extract-plugin
module.exports = {"formcontainer":"Calculation_formcontainer__24Z_a","total":"Calculation_total__1vo1D","risknote":"Calculation_risknote__1nFAl"};